import React from 'react'
import Nav from './Nav'
import ContactForm from './ContactForm'

export default function About() {
    return (
        <div className="page-content">
            <Nav />
            <main className='about-page'>
                <div className="about-content">
                    <img className='about-image' src={require('../images/madelyn-in-kitchen-with-country-loaf.jpg')} alt='Madelyn baking' width="350px"/>
                    <section >
                        <h1>About One Thing Kneaded</h1>
                        <p>Hi! I'm Maddie! I started baking as a hobby in 2018, after my 3rd child was born and I needed something that was just mine. I had always had an interest in baking, but the baking show my mom and I did in our kitchen, "Baking With Maddie and Mommy," never made it past the pilot stage. While my husband and I were dating, we made the Nestle Tollhouse chocolate chip cookie recipe on the back of the bag more times than I can count. Undercooked dough is still one of my favorite things. I started One Thing Kneaded in April of 2022, so that I could share my bakes with others. </p>
                        <ContactForm/>
                    </section>
                </div>
             </main>
        </div>
    )
}